document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper(".jtcSwiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false
    }, 
    slidesPerView: 1.5,   
    spaceBetween: 12, 
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 480px
    768: {
      slidesPerView: 3.3
    },
    // when window width is >= 640px
    1280: {
      slidesPerView: 4.5
    },
    1920: {
      slidesPerView: 7
    }
  }    
  });
  });

  const jtcSwiper = document.querySelector('.jtcSwiper');

  const intervalID = setInterval(loadFunc, 250);

  function loadFunc()
  {
    if (jtcSwiper.classList.contains('swiper-initialized')) {
      clearInterval(intervalID);

      setTimeout(() => {
        jtcSwiper.classList.add('loaded');
      }, 400);
    }
  }